import httpClient from "@/http-client";

export const index = (bankId, options = {}) => {
    return httpClient
        .get(`/api/bank-profiles/${bankId}/accounts`, options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = (bankId, data) => {
    return httpClient
        .post(`/api/bank-profiles/${bankId}/accounts`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (accountId, data) => {
    return httpClient
        .put(`/api/bank-profiles/accounts/${accountId}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = accountId => {
    return httpClient
        .delete(`/api/bank-profiles/accounts/${accountId}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default { index, store, update, destroy };
